/** Agrupa os vínculos por município + UF, para exibir os cards de cidades */
export function agruparPorCidade(vinculos) {
  const map = new Map();
  (Array.isArray(vinculos) ? vinculos : []).forEach(option => {
    const escola = option?.escola || {};
    const municipio = (escola.municipio || '').trim() || 'Não informada';
    const uf = (escola.uf || '').trim();
    const chave = `${municipio}|${uf}`;
    if (!map.has(chave)) {
      map.set(chave, { chave, municipio, uf, escolas: [] });
    }
    map.get(chave).escolas.push(option);
  });
  return Array.from(map.values())
    .map(c => ({ ...c, total: c.escolas.length }))
    .sort((a, b) =>
      `${a.municipio}/${a.uf}`.localeCompare(`${b.municipio}/${b.uf}`, 'pt-BR', { sensitivity: 'base' })
    );
}

export default agruparPorCidade;
